import dayjs from "dayjs"

import { type ClassSessionConstructor } from "#customTypes/composedTypes/classSessionTypes"
import { type ProjectConstructor } from "#customTypes/composedTypes/projectTypes"
import { getSessionInfoFromId } from "#utils/classHelpers"
import { STANDARD_SESSION_DATE_FORMAT } from "#utils/dateHelpers"

export type MissedMakeupSubtitleLines = {
  /** Project title for the first row; callers can render it as text or a link. */
  projectName: string
  /** Line 2: class name — M/D — Week # (class.name already has weekday, semester, time) */
  classInfoLine: string
}

/**
 * Teacher makeup subtitle text: project name for the first row, class + missed date + week for the second.
 * Week # = sessionIndex + 1 from composite session id.
 */
export const getMissedMakeupSubtitleLines = (
  className: string | undefined,
  session: ClassSessionConstructor | null | undefined,
  project: ProjectConstructor | null | undefined
): MissedMakeupSubtitleLines | null => {
  if (!session?.eventStart || !session.id) return null

  const [, sessionIndex] = getSessionInfoFromId(session.id)
  const weekNumber = sessionIndex + 1

  const datePart = dayjs(session.eventStart).format(
    STANDARD_SESSION_DATE_FORMAT
  )
  const displayClassName = className?.trim() || "Unknown class"
  const projectName = project?.name?.trim() || "Unknown project"
  const classInfoLine = `${displayClassName} - ${datePart} Week ${weekNumber}`

  return { projectName, classInfoLine }
}
